import {types} from './types';

const initialState = {
    list: [],
    view: {}
}

export function mobileSupportReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_SUPPORT_LIST:
            return { ...state, list: action.payload};
        case types.SET_SUPPORT_VIEW:
            return { ...state, view: action.payload};
        default:
            return state
    }
}